import React from 'react';
import PropTypes from 'prop-types';
import Download from './Download';

const Downloads = ({downloads}) => (
  <div className="mt3 pa3 bg-white flex flex-wrap">
    {downloads.edges.map((download, index) => (
      <Download key={index} {...download.node} />
    ))}
  </div>
);

Downloads.propTypes = {
  downloads: PropTypes.arrayOf(PropTypes.object),
};

export default Downloads;
